import dataService from "../../../services/data.service";
import { COMPARISON_DATA_TYPE } from "../../../constants/keywords";

/**
 * @param {object|null|undefined} comparison
 * @returns {boolean}
 */
export function hasConfiguredPlanComparison(comparison) {
  if (!comparison?.dataType) return false;

  if (comparison.dataType === "Snapshot") {
    const date = comparison.snapShotDate ?? comparison.snapshotDate;
    return date != null && String(date).trim() !== "";
  }

  // TPX-1902: Trailing 12 month is always "configured" once selected — the window is derived
  // server-side from the plan property's closed accounting month, so no extra fields are required.
  if (comparison.dataType === COMPARISON_DATA_TYPE.TRAILING_12) return true;

  return !!(comparison.compareToPropertyId || comparison.propertyId);
}

/**
 * @param {object|null|undefined} comparison
 * @param {object|null|undefined} planContext Plan being viewed ({ propertyIds?, fiscalYear? })
 * @returns {string|null}
 */
export function formatPlanComparisonLabel(comparison, planContext) {
  if (!hasConfiguredPlanComparison(comparison)) return null;

  const dataType = comparison.dataType || "N/A";
  const planType = comparison.planType || "N/A";
  const versionName = comparison.versionName || "N/A";
  const snapShotDate =
    comparison.snapShotDate ?? comparison.snapshotDate ?? "N/A";

  const propertyId =
    comparison.compareToPropertyId ||
    comparison.propertyId ||
    planContext?.propertyIds?.[0];
  const property = propertyId ? dataService.getPropertyById(propertyId) : null;
  const hmg = property ? property.name : "N/A";
  const year =
    comparison.year ??
    comparison.fiscalYear ??
    planContext?.fiscalYear ??
    "N/A";

  if (dataType === "Snapshot") {
    return `${hmg} | ${year} | ${planType} | Snapshot as-of ${snapShotDate}`;
  }
  if (dataType === "Actuals") {
    return `${hmg} | ${year} | ${dataType}`;
  }
  // TPX-1902: Trailing 12 month — the grid header/tooltip surface. Appends the resolved closed
  // accounting month ("as of MMM YYYY") when available; otherwise just the target name.
  if (dataType === COMPARISON_DATA_TYPE.TRAILING_12) {
    const asOf = comparison.closedMonthLabel
      ? ` (as of ${comparison.closedMonthLabel})`
      : "";
    return `${hmg} | Trailing 12 months${asOf}`;
  }
  return `${hmg} | ${year} | ${planType} | ${versionName}`;
}
